import {Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import { FrontUserNoActiveService } from '../../../../services/frontUsersNoActive.service';
import {CommunicationService} from '../../../../services/communication.service';
import {FuseConfigService} from '../../../../services/config.service';
import {AppConfig} from '../../../../../app.config';
import {Subscription} from 'rxjs';

@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls: ['./nav-vertical-item.component.scss'],
    standalone: false
})
export class FuseNavVerticalItemComponent implements OnInit, OnDestroy {
  @HostBinding('class') classes = 'nav-item';
  @Input() item: any;
  userCount;

  private subscriptions =  new Subscription();

  constructor(public frontUserNoActiveService: FrontUserNoActiveService, public communicationService: CommunicationService,
              private fuseConfig: FuseConfigService, private api: AppConfig) {
  }

  ngOnInit() {
    if (this.item && this.item.url && this.item.url.indexOf('frontusersnoactive') !== -1) {
     this.frontUserNoActiveService.getUsersCount().subscribe((res: any) => {
       if (+res) {
         this.item.badge = +res;
         this.userCount = +res;
       }
     });
    }
    if (this.item && this.item.url && this.item.url.indexOf('news') !== -1) {
      if (this.api.token) {
        this.communicationService.getAdminNewEmailsCount().subscribe((res: any) => {
          this.item.badge = +res;
        });
      }
      setInterval(() => {
        if (this.api.token) {
          this.communicationService.getAdminNewEmailsCount().subscribe((res: any) => {
            this.item.badge = +res;
          });
        }
      }, 300000);
      this.subscriptions.add(this.fuseConfig.impersonation.subscribe((result) => {
        if (this.item && this.item.url && this.item.url.indexOf('news') !== -1) {
          setTimeout(() => {
            if (this.api.token) {
              this.communicationService.getAdminNewEmailsCount().subscribe((res: any) => {
                this.item.badge = +res;
              });
            }
          }, 3000);
        }
      }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
